import React from 'react';
import styles from './FeatureItem.module.scss';

const FeatureItem = ({ icon, children, variant = 'default' }) => {
  return (
    <div className={`${styles.item} ${styles[variant]}`}>
      {icon ? (
        <div className={styles.iconWrapper}>
          {icon}
        </div>
      ) : (
        <svg
          className={styles.checkmark}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M13.3334 4L6.00002 11.3333L2.66669 8"
            stroke="#00A7B7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      <span className={styles.text}>{children}</span>
    </div>
  );
};

export default FeatureItem;
